import Api from '../api';
let uri = '/api/ed/tipoCaso';

let uriCaso = '/api/ed/casos';

export const getTipoCaso = (data) => {
    return Api.getInstance().executeQuery(`${uri}`, data)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const generarCasoEspecial = (data) => {
    return Api.getInstance().executeQuery(`${uriCaso}`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}

export const modificarCasoEspecial = (data) => {
    return Api.getInstance().executeUpdateQuery(`${uriCaso}`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}

export const reenvioCasoEspecial = (data) => {
    return Api.getInstance().executeUpdateQuery(`${uriCaso}/reenvio`, data)
    .then((resp) => resp)
    .catch((error) =>
        console.log(error)
    );
}

export const updateFoto = (data)  => {
    return Api.getInstance().executeUpdateQuery(`${uriCaso}/foto`, data)
    .then(res => res)
    .catch(err => console.log(err));
}

export const getCasosAsistente = (data) => {
    return Api.getInstance().executeQuery(`${uriCaso}/list`, data)
    .then((resp) => resp.data)
    .catch((error) =>
        console.log(error)
    );
}

export const getHistorialCaso = (data) => {
    return Api.getInstance().executeQuery(`${uriCaso}/historial`, data)
    .then(res => res.data)
    .catch(err => console.log(err));
}